import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';

/**
 * Bouton toggle thème sombre/clair.
 * Peut s'utiliser partout : sidebar, topbar mobile, profil…
 * Props :
 *   - size   : 'sm' | 'md' (default 'md')
 *   - showLabel : bool (default false)
 */
export const ThemeToggle = ({ size = 'md', showLabel = false }) => {
  const { dark, toggle } = useTheme();

  const iconSize  = size === 'sm' ? 15 : 18;
  const btnClass  = size === 'sm'
    ? 'p-1.5 rounded-full'
    : 'p-2 rounded-full';

  return (
    <button
      onClick={toggle}
      aria-label={dark ? 'Passer en thème clair' : 'Passer en thème sombre'}
      title={dark ? 'Mode clair' : 'Mode sombre'}
      className={`${btnClass} transition-colors
        text-stone-500 hover:text-forest
        bg-transparent hover:bg-stone-100 dark:hover:bg-stone-800
        flex items-center gap-2`}
    >
      {dark
        ? <Sun  size={iconSize} className="text-amber-400" />
        : <Moon size={iconSize} className="text-stone-500" />}
      {showLabel && (
        <span className="text-sm font-medium">
          {dark ? 'Mode clair' : 'Mode sombre'}
        </span>
      )}
    </button>
  );
};
